import request from "@/utils/request";

// 组织部门-分页查询
export const postOrganizationalPage = (data) => {
  return request({
    url: "/urinePC/organizational/page",
    method: "post",
    data
  });
};

// 组织部门-获取组织树
export const getOrganizationalGetOrganizationalTree = (params) => {
  return request({
    url: "/urinePC/organizational/getOrganizationalTree",
    method: "get",
    params
  });
};

// 组织部门-查询获取组织树
export const getOrganizationalGetOrganizationalTreeSelect = (params) => {
  return request({
    url: "/urinePC/organizational/getOrganizationalTreeSelect",
    method: "get",
    params
  });
};

// 组织部门-新增
export const postOrganizationalSave = (data) => {
  return request({
    url: "/urinePC/organizational/save",
    method: "post",
    data
  });
};

// 组织部门-修改
export const postOrganizationalUpdate = (data) => {
  return request({
    url: "/urinePC/organizational/update",
    method: "post",
    data
  });
};

// 组织部门-删除
export const deleteOrganizationalDelete = (params) => {
  return request({
    url: `/urinePC/organizational/delete/${params?.id ?? params}`,
    method: "DELETE"
  });
};

// -----------------------------------------

// 组织部门-详情
export const getOrganizational = (params) => {
  return request({
    url: `/urinePC/organizational/${params?.id ?? params}`,
    method: "get"
  });
};

// -----------------------------------------

// 字典类型-分页查询
export const postDictTypePage = (data) => {
  return request({
    url: "/urinePC/dictType/page",
    method: "post",
    data
  });
};

// 字典类型-树形
export const getDictTypeGetDictTpyeTree = (params) => {
  return request({
    url: "/urinePC/dictType/getDictTpyeTree",
    method: "get",
    params
  });
};

// 字典类型-树形支持查询
export const getDictTypeGetDictTpyeTreeBySelect = (params) => {
  return request({
    url: "/urinePC/dictType/getDictTpyeTreeBySelect",
    method: "get",
    params
  });
};

// 字典类型-根据字典类型查询字典数据
export const getDictTypeGetDictByType = (params) => {
  return request({
    url: "/urinePC/dictType/getDictByType",
    method: "get",
    params
  });
};

// 字典类型-新增
export const postDictTypeSave = (data) => {
  return request({
    url: "/urinePC/dictType/save",
    method: "post",
    data
  });
};

// 字典类型-修改
export const postDictTypeUpdate = (data) => {
  return request({
    url: "/urinePC/dictType/update",
    method: "post",
    data
  });
};

// 字典类型-删除
export const deleteDictTypeDelete = (params) => {
  return request({
    url: `/urinePC/dictType/delete/${params?.id ?? params}`,
    method: "DELETE"
  });
};

// -----------------------------------------

// 字典数据-分页查询
export const postDictDataPage = (data) => {
  return request({
    url: "/urinePC/dictData/page",
    method: "post",
    data
  });
};

// 字典数据-不分页查询
export const postDictDataList = (data) => {
  return request({
    url: "/urinePC/dictData/list",
    method: "post",
    data
  });
};

// 字典数据-新增
export const postDictDataSave = (data) => {
  return request({
    url: "/urinePC/dictData/save",
    method: "post",
    data
  });
};

// 字典数据-编辑
export const postDictDataUpdate = (data) => {
  return request({
    url: "/urinePC/dictData/update",
    method: "post",
    data
  });
};

// 字典数据-删除
export const deleteDictDataDelete = (params) => {
  return request({
    url: `/urinePC/dictData/delete/${params?.id ?? params}`,
    method: "DELETE"
  });
};

// -----------------------------------------

// 岗位-分页查询
export const postPostPage = (data) => {
  return request({
    url: "/urinePC/post/page",
    method: "post",
    data
  });
};

// 岗位-不分页查询
export const postPostList = (data) => {
  return request({
    url: "/urinePC/post/list",
    method: "post",
    data: { ...data }
  });
};

// 岗位-新增
export const postPostSave = (data) => {
  return request({
    url: "/urinePC/post/save",
    method: "post",
    data
  });
};

// 岗位-编辑
export const postPostUpdate = (data) => {
  return request({
    url: "/urinePC/post/update",
    method: "post",
    data
  });
};

// 岗位-删除
export const deletePostDelete = (params) => {
  return request({
    url: `/urinePC/post/delete/${params?.id ?? params}`,
    method: "DELETE"
  });
};

// 岗位-详情
export const getPost = (params) => {
  return request({
    url: `/urinePC/post/${params?.postCode ?? params}`,
    method: "get"
  });
};

// -----------------------------------------

// 用户-分页查询
export const postUserPage = (data) => {
  return request({
    url: "/urinePC/user/page",
    method: "post",
    data
  });
};

// 用户-不分页查询
export const postUserList = (data) => {
  return request({
    url: "/urinePC/user/list",
    method: "post",
    data
  });
};

// 用户-根据组织code查询用户
export const postUserGetUserByOrgCode = (data) => {
  return request({
    url: "/urinePC/user/getUserByOrgCode",
    method: "post",
    data
  });
};

// 用户-根据组织code查询用户
export const getUserByOrgCode = (orgCode) => {
  return request({
    url: `/urinePC/authOrganizationalUser/allUser/${orgCode}`,
    method: "get"
  });
};

// 用户-新增
export const postUserSave = (data) => {
  return request({
    url: "/urinePC/user/save",
    method: "post",
    data
  });
};

// 用户-编辑
export const postUserUpdate = (data) => {
  return request({
    url: "/urinePC/user/update",
    method: "post",
    data
  });
};

// 用户-删除
export const deleteUserDelete = (params) => {
  return request({
    url: `/urinePC/user/delete/${params?.id ?? params}`,
    method: "DELETE"
  });
};

// 用户-批量删除
export const deleteUserDeleteBatch = (params) => {
  return request({
    url: `/urinePC/user/deleteBatch/${params?.id ?? params}`,
    method: "DELETE"
  });
};

// 用户-详情
export const getUser = (params) => {
  return request({
    url: `/urinePC/user/${params?.userCode ?? params}`,
    method: "get"
  });
};

// 用户-重置密码
export const postUserResetPassword = (data) => {
  return request({
    url: `/urinePC/user/resetPassword`,
    method: "post",
    data
  });
};

// 用户-下载导入模板
export const getUserDownloadLoginTemplate = (params) => {
  return request({
    url: "/urinePC/user/downloadLoginTemplate",
    method: "get",
    params,
    responseType: "blob"
  });
};

// 用户-模板导入
export const postUserImportByTemplate = (data) => {
  return request({
    url: "/urinePC/user/importByTemplate",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
};

// 根据用户登陆token获取用户信息和菜单
export const getUserGetUserByLoginToken = () => {
  return request({
    url: `/urinePC/user/getUserByLoginToken`,
    method: "get"
  });
};

// 修改密码
export const updatePasswordByPhoneNumber = (data) => {
  return request({
    url: "/urinePC/user/updatePassword",
    method: "POST",
    data
  });
};
// -----------------------------------------

// 角色-分页查询
export const postRolePage = (data) => {
  return request({
    url: "/urinePC/role/page",
    method: "post",
    data
  });
};

// 角色-不分页查询
export const postRoleList = (data) => {
  return request({
    url: "/urinePC/role/list",
    method: "post",
    data
  });
};

// 角色-新增
export const postRoleSave = (data) => {
  return request({
    url: "/urinePC/role/save",
    method: "post",
    data
  });
};

// 角色-编辑
export const postRoleUpdate = (data) => {
  return request({
    url: "/urinePC/role/update",
    method: "post",
    data
  });
};

// 角色-删除
export const deleteRoleDelete = (params) => {
  return request({
    url: `/urinePC/role/delete/${params?.id ?? params}`,
    method: "DELETE"
  });
};

// 角色-删除
export const deleteRoleDeleteBatch = (params) => {
  return request({
    url: `/urinePC/role/deleteBatch/${params?.id ?? params}`,
    method: "DELETE"
  });
};

// 角色-详情
export const getRole = (params) => {
  return request({
    url: `/urinePC/role/${params?.roleCode ?? params}`,
    method: "get"
  });
};
// -----------------------------------------

// 菜单-菜单树
export const getMenuGetMenuTree = () => {
  return request({
    url: "/urinePC/menu/getMenuTree",
    method: "get"
  });
};

// 菜单-菜单树支持查询
export const getMenuGetMenuTreeSelect = (params) => {
  return request({
    url: "/urinePC/menu/getMenuTreeSelect",
    method: "get",
    params
  });
};

// 菜单-分页查询
export const postMenuPage = (data) => {
  return request({
    url: "/urinePC/menu/page",
    method: "post",
    data
  });
};

// 菜单-根据组织code查询菜单
export const getMenu = (params) => {
  return request({
    url: `/urinePC/menu/${params?.menuCode ?? params}`,
    method: "get"
  });
};

// 菜单-新增
export const postMenuSave = (data) => {
  return request({
    url: "/urinePC/menu/save",
    method: "post",
    data
  });
};

// 菜单-编辑
export const postMenuUpdate = (data) => {
  return request({
    url: "/urinePC/menu/update",
    method: "post",
    data
  });
};

// 菜单-删除
export const deleteMenuDelete = (params) => {
  return request({
    url: `/urinePC/menu/delete/${params?.id ?? params}`,
    method: "DELETE"
  });
};

// 用户管理-保存权限
export const postAuthDataPermissionSave = (data) => {
  return request({
    url: `/urinePC/user/updateDataPermission`,
    method: "POST",
    data
  });
};

// 水务大脑大屏-配置详情
export const getModuleConfigDetail = (params) => {
  return request({
    url: "/api/analysis/module-config/detail",
    method: "get",
    params
  });
};

// 水务大脑大屏-保存配置
export const postModuleConfig = (data) => {
  return request({
    url: "/api/analysis/module-config",
    method: "post",
    data
  });
};

